
import { defineComponent } from 'vue';
import Slot from "@/sandbox/slot/Slot.vue";

export default defineComponent({
  components: {
    Slot
  },
  // setup() {
  // }
});
